import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { FIELD_TYPES } from 'common/hooks/useForm'
import { maskFuntions } from 'src/features/price-policies/constants'

export default async function getAllConventionalBonificationsByVersions({
  carlotSelected = [],
  stateFilters = {}
}) {
  let query = ''
  carlotSelected.forEach(carLot => {
      query = query + `car_lot_id[]=${carLot}&`
  })

  stateFilters.forEach((filter)=> {
    if(filter.type === FIELD_TYPES.CHECKBOXES){
      query = query + `${filter.keyBackend}[]=${filter.value}&`
    } else {
      query = query + `${filter.keyBackend}=${maskFuntions.removeMask(filter.value)}&`
    }
  })

  query = query.slice(0, -1)

  const response = await axios(
      `${REACT_APP_API}/bonifications/conventional/version?${query}`
  )

  return response?.data?.data || []
}
